export default "__VITE_ASSET__DcTIzNd$__"